import { AbstractConnector } from '@web3-react/abstract-connector'
import { InjectedConnector } from '@web3-react/injected-connector'
import { FortmaticConnector } from '@web3-react/fortmatic-connector'
import { PortisConnector } from '@web3-react/portis-connector'
import { WalletConnectConnector } from '@web3-react/walletconnect-connector'
import { WalletLinkConnector } from '@web3-react/walletlink-connector'
import { isMobile } from 'react-device-detect'
import { SUPPORTED_CHAINS, ChainId, FORMATIC_MAINNET_API_KEY, PORTIS_DAPP_ID, INFURA_URLS } from '../constants'
import genericIcon from '../assets/wallets/generic.svg'
import metamaskIcon from '../assets/wallets/metamask.svg'
import fortmaticIcon from '../assets/wallets/fortmatic.svg'
import portisIcon from '../assets/wallets/portis.svg'
import walletConnectIcon from '../assets/wallets/walletConnect.svg'
import walletLinkIcon from '../assets/wallets/walletLink.svg'
import INTEGRAL_LOGO_URL from '../assets/logo.svg'

export interface Wallet {
  connector: AbstractConnector
  label: string
  iconUrl: string
}

export const injected = new InjectedConnector({
  supportedChainIds: SUPPORTED_CHAINS,
})

const INJECTED = {
  connector: injected,
  label: 'Injected',
  iconUrl: genericIcon,
}

const METAMASK = {
  connector: injected,
  label: 'MetaMask',
  iconUrl: metamaskIcon,
}

const FORTMATIC = {
  connector: new FortmaticConnector({
    apiKey: FORMATIC_MAINNET_API_KEY,
    chainId: ChainId.Mainnet,
  }),
  label: 'Fortmatic',
  iconUrl: fortmaticIcon,
}

const PORTIS = {
  connector: new PortisConnector({
    dAppId: PORTIS_DAPP_ID,
    networks: SUPPORTED_CHAINS,
  }),
  label: 'Portis',
  iconUrl: portisIcon,
}

const WALLET_CONNECT = {
  connector: new WalletConnectConnector({
    rpc: INFURA_URLS,
    qrcode: true,
    supportedChainIds: SUPPORTED_CHAINS,
  }),
  label: 'WalletConnect',
  iconUrl: walletConnectIcon,
}

const WALLET_LINK = {
  connector: new WalletLinkConnector({
    url: INFURA_URLS[ChainId.Mainnet],
    appName: 'Integral',
    appLogoUrl: INTEGRAL_LOGO_URL,
  }),
  label: 'Coinbase Wallet',
  iconUrl: walletLinkIcon,
}

const MOBILE_WALLETS: Wallet[] = [WALLET_CONNECT, WALLET_LINK, FORTMATIC, PORTIS]
const WALLETS: Wallet[] = [WALLET_CONNECT, WALLET_LINK, FORTMATIC, PORTIS]

export function getSupportedWallets(window: any) {
  const isMetamask = window.ethereum && window.ethereum.isMetaMask
  const isInjected = window.web3 || window.ethereum

  const supportedWallets = (isMobile ? MOBILE_WALLETS : WALLETS).slice(0)
  if (isMetamask) {
    supportedWallets.unshift(METAMASK)
  } else if (isInjected) {
    supportedWallets.unshift(INJECTED)
  }

  return supportedWallets
}
